/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////// SPANISH /////////////////////////////
/// ///////////////////////////////////////////////////////////////
/// ///////////////////////////////////////////////////////////////
import { DASH_LINKS } from "../../../const/AppCardLinks";
/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <b>Proceso de Inicio de Sesión en el Portal para Padres EngagED (Interno/Externo)</b>,
    Interrupt_p1: (
        <>
            Para iniciar sesión en el Portal para Padres EngagED, emparejará su{" "}
            <b>nombre de usuario del Portal para Padres de Infinite Campus</b> ( padre externo: nombre de usuario que
            creó durante la configuración de la cuenta) <u>y</u> <b>@p.dcsdk12.org</b>. Por ejemplo: si su nombre de
            usuario de Infinite Campus es <b>jsmith</b>, ingresará <b>jsmith@p.dcsdk12.org</b> como su dirección de
            correo electrónico en la pantalla de inicio de sesión que sigue. Su <b>contraseña</b> es la misma que usa
            para acceder a Infinite Campus (padre externo: contraseña que creó durante la configuración de la cuenta).
        </>
    ),
    Interrupt_p2: (
        <>
            <b>Si ha olvidado sus credenciales de inicio de sesión de DCSD</b>:<br />
            Use estos enlaces para{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                recuperar su nombre de usuario
            </a>{" "}
            y/o{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                restablecer su contraseña
            </a>
            .
        </>
    ),
    Interrupt_p3: (
        <>
            <b>Si ha seguido los pasos anteriores y continúa teniendo dificultades, por favor contáctenos</b>
            :<br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Inglés
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Español
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Soporte Técnico para Padres - Chino
            </a>
            <br />
            Centro de Soporte Técnico en <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "NOTA: Los empleados del distrito que son padres actuales deben seguir las instrucciones anteriores utilizando una ventana de navegador de incógnito o privada y/o un navegador diferente.",
    Interrupt_submit: "Proceder a iniciar sesión",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Bienvenido,",
    Main_Nav_HelpfulLinks: "Vínculos útiles",
    Main_Nav_LogOut: "CERRAR SESIÓN",
    Main_Nav_HelpfulLinks_LI_s1: "Contactar el enfermero de mi estudiante",
    Main_Nav_HelpfulLinks_LI_s2: "Calendarios Académicos",
    Main_Nav_HelpfulLinks_LI_s3: "Recursos para padres",
    Main_Nav_HelpfulLinks_LI_s4: "Rutas de autobuses",
    Main_Nav_HelpfulLinks_LI_s5: "Pagos en línea",
    Main_Nav_HelpfulLinks_LI_s6: "Menus de almuerzo",
    Main_Nav_Exit: "SALIR",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Agregar",
    Global_Add_New_Student: "Agregar Nuevo Estudiante",
    Global_BackToDashboard: "Volver al panel de control",
    Global_Close: "Cerrar",
    Global_Completed: "Completado",
    Global_InProgress: "En Progreso",
    Global_GoTo: "Ir a",
    Global_MoreInfo: "Más información",
    Global_No_Student_1: "Bienvenido al Portal para Padres de EngagED",
    Global_No_Student_2: "Lo sentimos, no pudimos encontrar ningún estudiante asociado a su cuenta.",
    Global_No_Student_External: (
        <>
            Si está solicitando la Inscripción Abierta, haga clic en el botón &ldquo;
            <strong>Agregar Nuevo Estudiante</strong>
            &rdquo; para agregar a su estudiante. Si está solicitando para varios estudiantes, deberá agregar a cada
            estudiante individualmente.
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            Si no ve a su(s) estudiante(s) y están actualmente matriculados en una escuela de DCSD, comuníquese con el
            Centro de Soporte de TI al <strong>303-387-0001</strong>. Utilice el botón &ldquo;
            <strong>Agregar Nuevo Estudiante</strong>&rdquo; solo para agregar a su estudiante si no está actualmente
            matriculado en una escuela de DCSD y está solicitando la Inscripción Abierta.
        </>
    ),
    Global_NotStarted: "No Iniciado",
    Global_Open: "Abrir",
    Global_OpenFrom: "Abrir desde", // <some date> - <some date>
    Global_Status: "Estado",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Tablero del Tutor de DCSD",
    Breadcrumb_EPR: "Tutor de DCSD",
    Breadcrumb_Translations: "Las traducciones son experimentales",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "Lo sentimos, no podemos recuperar el PDF del EPR para el estudiante de",
    EPR_Failure2:
        "Por favor, proporcione la siguiente información cuando se ponga en contacto con el distrito para solicitar ayuda:",
    EPR_NoData: "No se encontraron EPR históricos para el estudiante.",
    EPR_Success: "El PDF del EPR se recuperó con éxito para el estudiante.",
    EPR_Title: "Recursos de EPR Archivados",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "Todas las ventanas de solicitud están actualmente cerradas.",
    NoApp_Body2: "Si cree que esto es un error, comuníquese con el distrito para obtener ayuda.",
    NoApp_Closed: "Cerrado",
    NoApp_Header: "No hay solicitudes disponibles",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "Bienvenido al Tablero del Tutor de DCSD",
    Welcome_Tagline:
        "Colaborando con los padres para seleccionar el mejor ambiente de aprendizaje para cada estudiante.",
    Welcome_p1: (
        <p>
            Empoderamos a las familias para encontrar la mejor opción educativa para sus hijos.{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                Aprender Más
            </a>
        </p>
    ),
    Welcome_p2: (
        <p>
            Las familias que deseen inscribir a su estudiante en una escuela distinta a la de su vecindario deben usar
            esta herramienta para solicitar la Inscripción Abierta (Open Enrollment) durante uno de los dos períodos de
            inscripción abierta que DCSD ofrece anualmente.{" "}
            <span className="highlight">
                No necesita usar esta herramienta de inscripción abierta para permanecer en su escuela de{" "}
                <b>inscripción actual</b>.
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5>
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                Haga clic aquí
            </a>{" "}
            para obtener instrucciones paso a paso sobre cómo usar la herramienta.
        </h5>
    ),
    Welcome_ImportantDates: "Fechas/Horas Importantes",
    Welcome_FirstWindow: "Primera Ventana",
    Welcome_SecondWindow: "Segunda Ventana",
    Welcome_ul_li1a: "La primera ronda de inscripción abierta NO es por orden de llegada; tiene hasta el ", // [DATE]
    Welcome_ul_li1b: "para completar este proceso.",
    Welcome_ul_li2a:
        "Para la primera ronda, puede cambiar sus opciones de solicitud de inscripción abierta en cualquier momento hasta el ", // [DATE]
    Welcome_ul_li3: "Las escuelas harán ofertas a las familias según la disponibilidad de espacio.",
    Welcome_ul_li4a: "Las ofertas no serán visibles para usted hasta después del ", // [DATE]
    Welcome_ul_li4b: (
        <>
            Puede volver a iniciar sesión en el{" "}
            <a href={DASH_LINKS.guardian}>
                Portal para Padres EngagED
            </a>{" "}
            a partir del
        </>
    ), // [DATE]
    Welcome_ul_li4c: "para verificar cualquier oferta que haya recibido.",
    Welcome_ul_li5a: "Tiene hasta el ", // [DATE]
    Welcome_ul_li5b: (
        <>
            para aceptar una oferta de inscripción abierta de una escuela a través del{" "}
            <a href={DASH_LINKS.guardian}>
                Portal para Padres EngagED.
            </a>
        </>
    ),
    Welcome_ul_li6a:
        "Si su solicitud de inscripción abierta no es aceptada por ninguna escuela, o si no inició sesión y aceptó su oferta, será colocado automáticamente en la lista de espera de la segunda ronda de inscripción abierta, que se extiende desde ", // [DATE RANGE]
    Welcome_NotAvailable: "El proceso de Inscripción Abierta para el año escolar actual aún no está disponible.",
    Welcome_PreschoolInfo: "Información de Kindergarten/Preescolar",
    Welcome_Note: "NOTA",
    Welcome_NoSupport: "Esta aplicación no admite la solicitud a preescolares de DCSD.",
    Welcome_PreschoolsLink: (
        <>
            Para preescolares de DCSD,{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <b>haga clic en este enlace</b>.
            </a>
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            Los padres que deseen inscribir a sus hijos de tres y cuatro años en los preescolares del distrito no pasan
            por la inscripción abierta. La inscripción de preescolar tendrá lugar a principios de enero. Siga este{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <b>enlace</b>{" "}
            </a>
            para más información.
        </>
    ),
    Welcome_CharterSchoolInfo: "Información sobre Escuelas Charter",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>Las siguientes Escuelas Charter utilizarán la herramienta este año:</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>
                    Por favor, contacte directamente a todas las demás escuelas Charter para obtener más información
                    sobre las opciones de inscripción para escuelas charter.
                </u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <i>Aspen View Academy</i>
                </li>
                <li>
                    <i>Ben Franklin Academy</i>
                </li>
                <li>
                    <i>Challenge to Excellence</i>
                </li>
                <li>
                    <i>DCS Montessori Charter</i>
                </li>
                <li>
                    <i>Leman Academy of Excellence</i>
                </li>
                <li>
                    <i>Parker Performing Arts School</i>
                </li>
                <li>
                    <i>SkyView Academy</i>
                </li>
                <li>
                    <i>STEM Academy</i>
                </li>
                <li>
                    <i>World Compass Academy</i>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "Información de Transporte",
    Welcome_TransportationBody:
        "El transporte para los estudiantes residentes a quienes se les concede permiso para asistir a una escuela o programa fuera de su área de asistencia de vecindario será proporcionado por su padre/tutor.",
    Welcome_GeneralInfo: "Información General",
    Welcome_GeneralInfo_ul2_li1:
        "Puede solicitar que se le envíe un correo electrónico de confirmación después de que su solicitud haya sido enviada.",
    Welcome_GeneralInfo_ul2_li2:
        "Puede optar por recibir sus opciones por correo electrónico después de haber completado la inscripción abierta.",
    Welcome_GeneralInfo_ul2_li3:
        "La segunda ronda de inscripción abierta es por orden de llegada. Los estudiantes que solicitan inscripción abierta solo en la segunda ronda se colocan en la lista de espera detrás de aquellos que ya están en la lista de espera de la primera ronda.",
    Welcome_GeneralInfo_ul2_li4: (
        <>
            Si está inscrito en una escuela de vecindario mediante inscripción abierta o asiste a una charter pero desea
            regresar a la escuela de vecindario asociada con su dirección para el próximo año escolar, debe presentar un{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                formulario de intención de regresar
            </a>{" "}
            <b>antes del</b>
        </>
    ), // [DATE],
    Welcome_GeneralInfo_li5: (
        <>
            Si se muda dentro del distrito pero desea permanecer en su escuela actual, puede hacerlo presentando un
            formulario de{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                intención de permanecer
            </a>{" "}
            en cualquier momento.
        </>
    ),

    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "Grado",
    Marquee_School: "Escuela",
    Marquee_Address: "Dirección",
    Marquee_NewStudent: "Nuevo Estudiante",
    Marquee_NotAvailable: "No Disponible",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "Inscripción Abierta (Open Enrollment)",
    OEApp_Btn1: "Iniciar Inscripción Abierta",
    OEApp_Btn2: "Administrar Opciones de Escuela",
    OEApp_Btn3: "Ver Información del Estudiante",
    OEApp_Btn4: "Editar Información del Estudiante",
    OEApp_Btn5: "Seleccionar Opciones de Escuela",
    OEApp_Btn6: "Inscripción Abierta",
    OEApp_Schools: "Opciones de Escuela Realizadas",
    OEApp_School: "Opción de Escuela Realizada",
    OEApp_NoSchools: "No se han realizado elecciones de escuela",
    OEApp_1School: "1 elección de escuela realizada",
    OEApp_MoreSchools: "elecciones de escuela realizadas",
    OEApp_Body:
        "Proceso de solicitud para que los padres elijan la consideración de inscripción para su(s) estudiante(s) en las escuelas de vecindario y charter de DCSD.",
    OEApp_Round1: "Ronda 1",
    OEApp_Round2: "Ronda 2",
    OEApp_RoundClosed: "Ronda 1 cerrada. Por favor, regrese para la Ronda 2 a partir del ", // [DATE]
    OEApp_SchoolChoices: "Opciones de Escuela",
    OEApp_RequestStatus: "Estado de la Solicitud",
    OEApp_LanguageChoice: "Opción de Idioma",
    OEApp_KinderChoice: "Opción de Kindergarten",
    OEApp_LanguageOffer: "Oferta de Idioma",
    OEApp_KinderOffer: "Oferta de Kindergarten",
    OEApp_FullDay: "Día Completo",
    OEApp_HalfDayPM: "Medio Día PM",
    OEApp_HalfDayAM: "Medio Día AM",
    OEApp_Spanish: "Español",
    OEApp_Mandarin: "Mandarín",
    OEApp_French: "Francés",
    OEApp_NewStudent: "Nuevo Estudiante",
    OEApp_ACCEPT_OFFER: "Oferta Aceptada",
    OEApp_CANCELLED_REQUEST: "Solicitud Cancelada",
    OEApp_CHANGED_ENROLLMENT: "Dado de Baja",
    OEApp_CHOICE_CREATED: "Opción de Escuela Creada",
    OEApp_CHOICE_INCOMPLETE: "Opción Incompleta",
    OEApp_DENY_OFFER: "Oferta Rechazada",
    OEApp_DENY_REQUEST: "Solicitud Rechazada",
    OEApp_ENROLLED: "Inscrito",
    OEApp_INVALID: "Inválido",
    OEApp_MAKE_OFFER: "Oferta Realizada",
    OEApp_MAKE_OFFER_PENDING: "Oferta Pendiente",
    OEApp_NO_RESPONSE: "Sin Respuesta",
    OEApp_WAIT_LIST: "En Lista de Espera",
    OEApp_REQUEST: "Solicitud Realizada",
    OEApp_UNENROLLED: "Dado de Baja",
    OEApp_UNAVAILABLE: "No Disponible",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "Registro Rápido (Express Check-In)",
    ECApp_Btn1: "Check-in Rápido",
    ECApp_Body:
        "Proceso anual de registro de estudiantes para que los padres actualicen y/o verifiquen la información actual de la dirección del hogar, consentimiento de medios, contactos de emergencia, condiciones de salud y mucho más.",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App ///////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "Próximamente. Vea el Informe de Progreso Elemental de su estudiante.",
    EPRApp_Header: "Informe de Progreso Elemental",
    EPRApp_Btn1: "Informe de Progreso de Primaria",
    EPRApp_Btn2: "Ver EPR Archivados",
    EPRApp_Semester: "Semestre",
    EPRApp_1stSemester: "Primer Semestre",
    EPRApp_2ndSemester: "Segundo Semestre",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "Administrar solicitudes de exclusión de evaluaciones.",
    AEApp_Header: "Exclusiones de Evaluación",
    AEApp_Excusal: "Exclusión",
    AEApp_Excusals: "Exclusiones",
    AEApp_NoExcusals: "Sin Exclusiones",
    AEApp_MoreExcusals: "Exclusiones",
    AEApp_Btn1: "Exenciones de evaluación",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1:
        "Solicitar un pase de autobús y/o elegir opciones de pago anual/trimestral para los viajes en autobús.",
    BusApp_Body2: "Solicitar pase de autobús",
    BusApp_Header: "Transporte",
    BusApp_Btn1: "Transporte",
    BusApp_BusPass: "Pase de Autobús Emitido",
    BusApp_NoBusPass: "Sin Pase de Autobús Emitido",
    BusApp_NotRiding: "No Usa el Autobús",
    BusApp_NotRidingReason1: "Ha indicado que ", // [NAME]
    BusApp_NotRidingReason2: " no usará el autobús este año.",
    BusApp_NotRidingReason3: "Usted ha indicado que el estudiante no utilizará el autobús este año",
    BusApp_Processing: "Procesando Pase de Autobús",
    BusApp_AnnualOffer: "Oferta de Pase Anual hasta ", // [DATE]
    BusApp_Quarterly: "Ha elegido Facturación Trimestral. Puede optar por la Facturación Anual antes del ", // [DATE]
    BusApp_BusPassIssued: (
        <>
            Su pase de autobús ha sido emitido. Ya puede usar el autobús.
            <br />
            Si una tarjeta se daña o se pierde, se puede solicitar un pase de autobús de reemplazo a través de{" "}
            <a
                className="anchor"
                href="https://www.k12insight.com/Lets-Talk/DialogueCustom.aspx?k=WK3Z6DLT@DG2T5DLT"
                rel="noreferrer"
                target="_blank"
            >
                Let&apos;s Talk
            </a>
            .
        </>
    ),
    BusApp_BusPassProcessing: "Su solicitud de Pase de Autobús aún está en proceso.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "Cargando Inscripción Abierta",
    Loading_2: "Cargando Registro Rápido",
    Loading_3: "Cargando EPR",
    Loading_4: "Cargando Exclusiones de Evaluación",
    Loading_5: "Cargando Transporte",
    Loading_6: "Cargando Encuesta",
    Loading_7: "Cargando Mensaje de Difusión"
};
/* eslint-enable */
